module.exports = __webpack_public_path__ + "img/jacobsen_Groenn_Poesi1.416383b4.jpg";